export default [
	{
		path: '/acessar',
		component: () => import('@/layouts/Login'),
		children: [{
			path: '',
			component: () => import('@/pages/Login/Acessar/Pages/Index'),
			name: 'Acessar',
			meta: {
				title: 'siS - Acessar',
				noCache: true
			}
		}]
	}
]